export enum Scope {
    TASKS_READ = "onboarding-tasks:read",
    TASKS_WRITE = "onboarding-tasks:write",
    MILESTONES_READ = "onboarding-milestones:read",
    MILESTONES_WRITE = "onboarding-milestones:write",
    NOTES_READ = "onboarding-notes:read",
    NOTES_WRITE = "onboarding-notes:write",
    EMPLOYEES_READ = "employees:read",
}

export const ALL_SCOPES = Object.values(Scope).filter(s => !process.env.NEXT_PUBLIC_EXCLUDE_SCOPES?.split(",").includes(s) ?? s)
